import {BarChart} from '@crema/modules/thirdParty';
export default BarChart;
